import { ReactNode } from 'react';
import { useRouterState } from '@tanstack/react-router';

import { ErrorBoundary } from './ErrorBoundary';

export function RouteErrorBoundary({ children }: { children: ReactNode }) {
  // The leaf match commits with the page; `location` moves before it and `resolvedLocation`
  // after it, so a key on either resets onto the wrong page.
  const leafMatchKey = useRouterState({
    select: (state) => {
      const leaf = state.matches[state.matches.length - 1];
      return leaf && `${leaf.id}${JSON.stringify(leaf.search)}`;
    }
  });

  return <ErrorBoundary resetKey={leafMatchKey}>{children}</ErrorBoundary>;
}
